export default __webpack_public_path__ + "static/media/fourthIconRight.2c5d9f45.svg";